export default "__VITE_ASSET__hxNnDjf7__"